import { render, staticRenderFns } from "./ZonaDetalle.vue?vue&type=template&id=0298894d&lang=true&"
import script from "./ZonaDetalle.vue?vue&type=script&lang=js&"
export * from "./ZonaDetalle.vue?vue&type=script&lang=js&"
import style0 from "./ZonaDetalle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports